
export default {
  data() {
    return {
      autoplaySuccess: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.setVideoAttributes();
    }, 300);
  },
  methods: {
    setVideoAttributes() {
      const video = document.getElementsByTagName("video");
      const attributes = {
        playsinline: "",
        preload: "auto",
        autoplay: "",
        muted: "",
        loop: "",
      };

      if (video && video[0]) {
        video[0].addEventListener("suspend", () => {
          video[0].play();
        });

        video[0].muted = true;
        video[0].playsinline = true;
        video[0].load();
        video[0].play();
        video[0].removeAttribute("controls");

        Object.keys(attributes).forEach((attr) => {
          video[0].setAttribute(attr, attributes[attr]);
        });

        const promise = video[0].play();

        if (promise !== undefined) {
          promise
            .then(() => {
              this.autoplaySuccess = true;
            })
            .catch((error) => {
              this.autoplaySuccess = false;
            });
        }
      }
    },
  },
};
